"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByBitFutureMarginCalculator = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureMarginCalculator_1 = require("./FutureMarginCalculator");
class ByBitFutureMarginCalculator extends FutureMarginCalculator_1.SingleFutureMarginCalculator {
    //获取维持保证金率
    getMaintenanceMarginRate(position, open_price) {
        let maintenance_margin_rate = new trade_utils_lib_1.SafeDecimal(0.005);
        let positionValue = position.mul(open_price).absoluteValue();
        while (positionValue.greaterThan(1000000)) {
            positionValue = positionValue.sub(1000000);
            maintenance_margin_rate = maintenance_margin_rate.add(0.005);
        }
        return maintenance_margin_rate;
    }
    getLiquidationPrice(initMargin, openPrice, position, leverage_rate, trend) {
        // 维持保证金率
        const mmRate = this.getMaintenanceMarginRate(position, openPrice);
        return FutureMarginCalculator_1.SingleFutureMarginCalculator.CalculateLiquidationPriceFunctionOne(mmRate, initMargin, openPrice, position, trend);
    }
}
exports.ByBitFutureMarginCalculator = ByBitFutureMarginCalculator;
